module.exports = __webpack_public_path__ + "static/media/logo.a144caf6.svg";